document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.wk-maps__leaflet').forEach(el => {
    const lat = parseFloat(el.dataset.lat);
    const lng = parseFloat(el.dataset.lng);
    const zoom = parseInt(el.dataset.zoom || '14', 10);

    if (isNaN(lat) || isNaN(lng)) return;

    const map = L.map(el).setView([lat, lng], zoom);

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      attribution: '&copy; OpenStreetMap'
    }).addTo(map);

    const title = el.dataset.title || '';
    const desc  = el.dataset.desc || '';
    const markerUrl = el.dataset.marker;

    let marker;
    if (markerUrl) {
      const icon = L.icon({ iconUrl: markerUrl, iconSize: [32, 32], iconAnchor: [16, 32] });
      marker = L.marker([lat, lng], { icon }).addTo(map);
    } else {
      marker = L.marker([lat, lng]).addTo(map);
    }

    if (title || desc) {
      marker.bindPopup(`<strong>${title}</strong><br>${desc}`);
    }
  });
});
